import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/common/auth.service';
import { AppCommonModule } from '@app/components/app.common.module';
import { BaseComponent } from '@app/components/base/base.component';
import { ModalService } from '@app/components/modal/modal.service';
import { environment } from '@env/environment.local';
import { queryParamsProducts } from '../../financial-setup/model.models';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { StandardQuoteService } from '../../../standard-quote-service.service';
import { FinancialProductService } from '../financial-product.service';
import { modelTypeEnum, modelTypeDescriptions} from '@app/pages/quote/open-quote/model/open-quote.model';
import {TippyDirective} from "@ngneat/helipopper";
import {
  conditions
} from "@app/pages/quote/standard-quote/catalogs/financial-product/list-financial-product/config-financial-product.model";
import { FinancialCalculatorService } from '@app/pages/quote/open-quote/services/financial-calculator.service';

@Component({
  selector: 'app-list-financial-product',
  standalone: true,
  imports: [AppCommonModule, TippyDirective],
  templateUrl: './list-financial-product.component.html',
  styleUrl: './list-financial-product.component.css'
})
export class ListFinancialProductComponent extends BaseComponent implements OnInit {
  // View Childs
  @ViewChild('templateConfirmation') template!: TemplateRef<any>;

  // Servicios
  public readonly financialCalculator = inject(FinancialCalculatorService);
  public readonly service = inject(FinancialProductService);
  public readonly serviceStandard = inject(StandardQuoteService);
  private readonly router = inject(Router);
  private readonly modalService = inject(ModalService);
  private readonly authService = inject(AuthService);

  // Atributos
  isLoading: boolean = false;
  hasData: boolean = false;
  isMobile: boolean = false;
  data: any[] = [];
  form: FormGroup;
  pageSize: number = environment.pageSize;
  pageIndex: number = 1;
  total: number = 0;
  params: queryParamsProducts = {
    modelType: null,
    brandId: null,
    subBrandId: null,
    year: null,
    classification: null,
    enabled: null,
    pageSize: this.pageSize,
    page: this.pageIndex,
  };

  title: string = 'Eliminar producto';
  subtitle: string = '';
  btn1: string = 'Cancelar';
  btn2: string = 'Eliminar';
  reset: boolean;
  resetSubBrand: boolean;
  idProduct: number;
  modelTypeDescriptions = modelTypeDescriptions;
  searchBrand: any[] = [];
  searchSubBrand: any[] = [];
  allSubBrands: any[] = [];
  searchYear: any[] = [];
  financialProducts: any[] = [];
  conditions = conditions
  financialProductStatus: any[] = [
    { label: 'Activo', value: true },
    { label: 'Inactivo', value: false}
  ];

  subBrandId!: number;

  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menu, notification);
  }

  ngOnInit(): void {
    this.route!.queryParams.subscribe(params => {
      this.subBrandId = params['subBrandId'];
      this.filter(this.subBrandId, 'subBrandId')
      this.search();
    });
    this.sendDataToMenu();
    this.initializeFilters();
  }

  initializeFilters() {
    this.service.getModels().subscribe(models => {
      this.financialProducts = models;
    });
    this.service.getBrand().subscribe({
      next: (response) => {
        this.searchBrand = response.data
          .map((brand: any) => { return { label: brand.brand, value: brand.id } })
          .sort((a: any, b: any) => {
            const labelA = (a.label || '').toLowerCase();
            const labelB = (b.label || '').toLowerCase();
            return labelA.localeCompare(labelB);
          });
      }
    });
    this.service.getSubBrand().subscribe({
      next: (response) => {
        this.allSubBrands = response.data
          .map((subBrand: any) => { 
            return { 
              label: subBrand.subBrand, 
              value: subBrand.id,
              brandId: subBrand.brandId 
            } 
          })
          .sort((a: any, b: any) => {
            const labelA = (a.label || '').toLowerCase();
            const labelB = (b.label || '').toLowerCase();
            return labelA.localeCompare(labelB);
          });
        this.searchSubBrand = [...this.allSubBrands];
      }
    });
    this.service.getYears().subscribe({
      next: (response) => {
        this.searchYear = response.data.map((year: any) => { return { label: year, value:year } })
      }
    });
  }

  addNewProduct() {
    this.router.navigate([
      `financial-product/new-product`,
    ]);
  }

  getList() {
    this.isLoading = true;
    this.service.getAllModels(this.params).subscribe({
      next: (response) => {
        this.data = response.data;
        this.total = response.totalElements;
        this.pageIndex = response.page;
        this.hasData = response.data.length > 0;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      },
    })
  }

  search() {
    this.params.page = 1;
    this.getList();
  }

  resetFilters() {
    this.params = {
      modelType: null,
      brandId: null,
      subBrandId: null,
      year: null,
      classification: null,
      enabled: null,
      pageSize: this.pageSize,
      page: 1,
    };

    this.searchSubBrand = [...this.allSubBrands];

    this.reset = true;
    this.resetSubBrand = true;

    setTimeout(() => {
      this.reset = false;
      this.resetSubBrand = false;
    }, 100);

    this.pageIndex = 1;
    this.getList();
  }


  openModalConfirmation() {
    this.modalService.component = this.template;
    this.modalService.openModal();
  }

  closeModal() {
    this.modalService.closeModal();
  }

  filter(value: any, typeField: string) {
    switch (typeField) {
      case 'modelType':
        this.params.modelType = value;
        break;
      case 'brandId':
        this.params.brandId = value;
        this.params.subBrandId = null;
        this.updateSubBrandsByBrand(value);
        break;
      case 'subBrandId':
        this.params.subBrandId = value;
        break;
      case 'year':
        this.params.year = value;
        break;
      case 'classification':
        this.params.classification = value;
        break;
      case 'enabled':
        this.params.enabled = value;
        break;
      case 'default':
        break;
    }
  }

  updateSubBrandsByBrand(brandId: number | null) {
    if (brandId == null || brandId === undefined) {
      this.searchSubBrand = [...this.allSubBrands];
    } else {
      const brandIdNum = Number(brandId);
      this.searchSubBrand = this.allSubBrands
        .filter((subBrand: any) => Number(subBrand.brandId) === brandIdNum);
    }
    this.resetSubBrand = true;
    setTimeout(() => {
      this.resetSubBrand = false;
    }, 100);
  }

  handlePage(e: any) {
    this.params.page = e.pageIndex + 1;
    this.params.pageSize = e.pageSize;
    this.getList();
  }

  view(idProduct: number) {
    this.router.navigate([`financial-product/read-only/${idProduct}`]);
  }

  edit(idProduct: number){
    this.router.navigate([`financial-product/edit-product/${idProduct}`])
  }

  getProductTypeDescription(type: modelTypeEnum): string {
    return this.modelTypeDescriptions[type] || 'Desconocido';
  }

}
